import 'array-from/polyfill'

if (!Array.from) {
    Array.from = require('array-from');
}